var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-section',{attrs:{"title":_vm.section.title,"subtitle":_vm.section.subtitle,"loading":_vm.loading,"error":_vm.error,"is-empty":!_vm.items.length,"variant":"authors","skeleton-variant":"authors","skeleton-count":6},on:{"retry":function($event){return _vm.$emit('retry', _vm.section)}}},[_c('home-author-rail',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }